import * as React from 'react'
import Layout from '$views/components/Layout'
import { FormContainer } from '$views/components/FormContainer'
import { Text } from '$views/components'
import { Icon } from '$views/components/Icon'
import { ButtonError404 } from './ButtonError'

const iconError404 = require('$icons/error404.svg')

const Error404: React.SFC = () => {
  return (
    <Layout>
      <FormContainer login>
        <Icon content={iconError404} />
        <Text title marginTop="medium">
          Página no encontrada!
        </Text>
        <Text marginTop="mini" marginBottom="mini">
          No hemos encontrado la página que estás buscando. Puede que no la hayas escrito bien o que la hayamos movido
          de sitio.
        </Text>
        <Text marginBottom="large">
          Vuelve atrás o si lo prefieres, ve a la home de Familiados. Y perdona las molestias!
        </Text>
        <ButtonError404 label={'Volver a la home de Familiados'} />
      </FormContainer>
    </Layout>
  )
}

export default Error404



// WEBPACK FOOTER //
// ./src/views/Error404/Error404.tsx